// extracted by mini-css-extract-plugin
export default {"container":"profile-tab_container__1PiRM","nav":"profile-tab_nav__clfqg","link":"profile-tab_link__ipm0d"};